import * as React from "react";
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  ButtonBase,
  createStyles,
  withStyles,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

interface FunnelSelectProps {
  from: any[];
  keyToDisplay: string;
  onSelect: (value: any) => void;
  defaultValue?: number | string;
}

export const FunnelSelect: React.FunctionComponent<FunnelSelectProps> = ({
  from,
  keyToDisplay,
  onSelect,
  defaultValue,
}: FunnelSelectProps) => {
  const [selected, setSelected] = React.useState(null);
  const classes = useStyles();
  React.useEffect(() => {
    setSelected(null);
  }, [from]);

  const timer = React.useRef(null);
  const handleSelect = (index: any, data: any) => () => {
    setSelected((prevState: any) => {
      clearTimeout(timer.current);
      if (prevState === index) {
        return null;
      }
      timer.current = setTimeout(() => {
        onSelect(data);
      }, 300);
      return index;
    });
  };

  if (!Array.isArray(from)) {
    return null;
  }

  const StyledListItem = withStyles({
    container: {
      width: "100%",
    },
    selected: {
      border: `solid 1px  "#005646"`,
    },
  })(ListItem);

  return (
    <List dense className={classes.list}>
      {from.map((data, index) => (
        <ButtonBase className={classes.buttonBase} key={index} onClick={handleSelect(index, data)}>
          <StyledListItem
            disableGutters
            className={classes.listItem}
            button
            selected={selected === index || defaultValue === index}
          >
            <ListItemText primary={data[keyToDisplay]} />
            <ListItemSecondaryAction>
              {(selected === index || defaultValue === index) && <CheckCircleIcon className={classes.icon} />}
            </ListItemSecondaryAction>
          </StyledListItem>
        </ButtonBase>
      ))}
    </List>
  );
};

const useStyles = makeStyles((theme: any) =>
  createStyles({
    list: {
      padding: 0,
      "& > button:not(:last-child)": {
        marginBottom: theme.spacing(2),
      },
    },
    buttonBase: {
      width: "100%",
      borderRadius: 8,
      color: theme.palette.secondary.main,
    },
    listItem: {
      padding: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1.5, 2),
      },
      borderRadius: 8,
      backgroundColor: theme.palette.common.white,
      color: "#1B1E1C",
      border: "solid 1px #dadee7",
      "&:hover": {
        border: "solid 1px #1a8e96",
      },
    },
    icon: {
      color: "#FF757B",
    },
  })
);
